import { Grid, Typography, TextField, FormControl, InputLabel, MenuItem } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import moment from "moment"
import { Control, Controller } from "react-hook-form"
import { EducationType } from "../Schemas/ResumeSchemas";

interface IProps {
    control: Control<EducationType, any>;
}

export const EducationFields = ({ control }:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid item sx={{overflowY: "auto"}}  maxHeight={"550px"} gap={'20px'} display={"flex"} flexDirection={"column"} paddingRight={4}>
                <Grid item display={"flex"} flexDirection={"row"} gap={"12px"}>
                    <Grid item xs display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>School</Typography>  
                        <Controller
                            name="school"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>(                 
                                <TextField
                                    {...field}
                                    fullWidth
                                    // error={hasErrors(field.name, errors)}
                                    placeholder='Name of school'
                                    sx={{
                                        width: "100%"
                                    }}
                                />
                            )}
                        />   
                    </Grid>
                    {/* <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                        <Box>
                            <IconButton onClick={handleSave}>
                                <Save />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={handleDelete}>
                                <Delete color='error'/>
                            </IconButton>
                        </Box>
                    </Grid> */}
                </Grid>
                <Grid item display={"flex"} flexDirection={"row"} gap={"12px"}>
                    <Grid item display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Degree</Typography>  
                        <Controller
                            name="title"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                <FormControl>   
                                    <InputLabel sx={{opacity: 1}}>{field.value ?"":"Degree"}</InputLabel>                   
                                    <TextField
                                        {...field}
                                        select
                                        // error={hasErrors(field.name, errors)}
                                        sx={{
                                            width: "270px"
                                        }}
                                    >{
                                        [
                                            "High School", 
                                            "Associates", 
                                            "Bachelors",
                                            "Masters",
                                            "PhD"
                                        ].map((language) => (
                                            <MenuItem key={language} value={language}>
                                                {language}
                                            </MenuItem>
                                        ))
                                    }
                                    </TextField >
                                </FormControl>
                            )}
                        />   
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Major</Typography>  
                        <Controller
                            name="major"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                <FormControl>   
                                    <InputLabel sx={{opacity: 1}}>{field.value ?"":"Major"}</InputLabel>                   
                                    <TextField
                                        {...field}
                                        // error={hasErrors(field.name, errors)}
                                        // select
                                        sx={{
                                            width: "270px"
                                        }}
                                    />
                                        {/* {
                                            [
                                                "English", 
                                                "French", 
                                                "Swahili"
                                            ].map((language) => (
                                                <MenuItem key={language} value={language}>
                                                    {language}
                                                </MenuItem>
                                            ))
                                        }
                                    </TextField> */}
                                </FormControl>
                            )}
                        />   
                    </Grid>
                </Grid>
                <Grid item display={"flex"} flexDirection={"row"} gap={"12px"}>
                    <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Start</Typography>  
                        <Controller
                            name="start_date"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>(      
                                <DatePicker
                                    {...field}
                                    disableFuture
                                    slotProps={{
                                        textField: {
                                            placeholder: 'Start month and year'
                                        },
                                        field: {
                                            clearable: true
                                        }
                                    }}
                                    value={field?.value ? moment(field.value).local() : undefined} 
                                    format='MM YYYY'
                                    views={['month', 'year']}                             
                                />
                            )}
                        />   
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>End</Typography>  
                        <Controller
                            name="end_date"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>(
                                <DatePicker
                                    {...field}
                                    disableFuture
                                    slotProps={{
                                        textField: {
                                            placeholder: 'End month and year'
                                        },
                                        field: {
                                            clearable: true
                                        }
                                    }}
                                    value={field?.value ? moment(field.value).local() : undefined} 
                                    format='MM YYYY'
                                    views={['month', 'year']}                              
                                />
                            )}
                        />   
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}